import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { useLang } from "../../context/LangContext";

export default function ForgotPassword() {
  const { lang } = useLang();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e2) {
      if (e2.code === "ECONNABORTED" || e2.message?.includes("timeout")) {
        setErr("Server unreachable. Please try again.");
      } else if (!e2.response) {
        setErr("Network error. Check your connection.");
      } else {
        const d = e2.response?.data?.detail;
        setErr(typeof d === "string" ? d : "Something went wrong");
      }
    } finally { setBusy(false); }
  };

  const t = {
    title: lang === "gr" ? "Επαναφορά κωδικού" : "Reset password",
    desc: lang === "gr"
      ? "Εισάγετε το email σας. Αν υπάρχει λογαριασμός, θα λάβετε σύνδεσμο επαναφοράς."
      : "Enter your email. If an account exists, you'll receive a reset link.",
    placeholder: lang === "gr" ? "Email" : "Email",
    submit: lang === "gr" ? "Αποστολή συνδέσμου" : "Send reset link",
    sent: lang === "gr"
      ? "Αν το email υπάρχει, σας στείλαμε σύνδεσμο επαναφοράς. Ελέγξτε τα εισερχόμενά σας."
      : "If that email exists, we sent a reset link. Check your inbox (and spam).",
    back: lang === "gr" ? "Επιστροφή στη σύνδεση" : "Back to sign in",
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-5" data-testid="forgot-password-page">
      <div className="card-dark p-10 w-full max-w-md">
        <div className="label-tag mb-3 slash">Admin access</div>
        <h1 className="display-font text-3xl font-black uppercase mb-3">{t.title}</h1>
        <p className="text-sm text-[#a0a0aa] mb-6">{t.desc}</p>

        {sent ? (
          <div data-testid="forgot-password-sent">
            <div className="mono-font text-xs text-[#d4ff00] border border-[#d4ff00]/40 p-4 mb-5">
              {t.sent}
            </div>
            <Link to="/admin/login" className="mono-font text-xs uppercase tracking-wider hover:text-[#d4ff00]" data-testid="forgot-back-link">
              ← {t.back}
            </Link>
          </div>
        ) : (
          <form onSubmit={submit}>
            <input
              type="email" required placeholder={t.placeholder} className="input-dark mb-5"
              value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email"
            />
            {err && <div className="mono-font text-xs text-[#ff003c] mb-3" data-testid="forgot-error">{err}</div>}
            <button disabled={busy} className="btn-primary w-full justify-center mb-4" data-testid="forgot-submit">
              {busy ? "..." : t.submit}
            </button>
            <Link to="/admin/login" className="mono-font text-xs uppercase tracking-wider hover:text-[#d4ff00]" data-testid="forgot-back-link">
              ← {t.back}
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
